/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptions, FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptions(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptions(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsBackground.js.map